import {P, StringUtil} from "oca-lib-web";
import { Cache } from 'aws-amplify';
import FlurryEventParamsAPI from "../api/FlurryEventParamsAPI";
import FlurryUsageAPI from "../api/FlurryUsageAPI";

// https://developer.yahoo.com/flurry/docs/api/code/analyticsapi/appusage/
// https://developer.yahoo.com/flurry/docs/api/code/analyticsapi/appevent/
export default class FlurryDataAccess {

    public static APPUSAGE = "appUsage";
    public static EVENTPARAMS = "eventParams";

    public static APPUSAGE_SESSIONS = "sessions";
    public static APPUSAGE_ACTIVEDEVICES = "activeDevices";
    public static APPUSAGE_ACTIVEUSERS = "activeUsers";
    public static APPUSAGE_NEWDEVICES = "newDevices";
    public static APPUSAGE_TIMESPENT = "timeSpent";
    public static APPUSAGE_AVGTIMEPERDEVICE = "avgTimePerDevice";
    public static APPUSAGE_AVGTIMEPERSESSION = "avgTimePerSession";
    public static APPUSAGE_MEDIANTIMEPERSESSION = "medianTimePerSession";

    public usage:Array<FlurryUsageModel> = [];
    public retention:Array<FlurryRetentionModel> = [];
    public eventParams:Array<FlurryEventParamModel> = [];

    // Fetch methods

    public clearData() {
        this.retention = [];
        this.usage = [];
        this.eventParams = [];
    }

    // Usage

    public async fetchUsage(timeInterval:TimeInterval, dataSource:DataSource): Promise<any> {
        this.loadUsageCacheIfAvailable();
        if (this.usage.length > 0) {
            console.log(this.usage);
            return P.resolve(this.usage);
        }

        var self = this;
        return new Promise<any>(async function(resolve) {
            /*var input = {
                field: InvokeFields.getFlurryUsage,
                dataSourceId: dataSource.id,
                fromDate: DashboardDateUtil.getPreviousTimeInterval().start,
                toDate: timeInterval.end,
                interval: timeInterval.interval
            }
            //self.usage = await getGlobal().data.getFlurryUsage(input);
            console.log(input);
            self.usage = await getGlobal().dataManager.get("getFlurryUsage", input);*/
            self.usage = await FlurryUsageAPI.get(timeInterval.start, timeInterval.end, timeInterval.interval, self.getApiKeys(dataSource));
            console.log("Usage", self.usage);
            console.log(self.usage);
            self.cacheUsageData();
            resolve(self.usage);
        });
    }

    public loadUsageCacheIfAvailable() {
        let cacheData = Cache.getItem("FlurryUsage");
        if (cacheData) {
            console.log("Loading FlurryUsage from cache");
            this.usage = cacheData;
        }
    }

    public cacheUsageData() {
        Cache.setItem("FlurryUsage", this.usage);
    }

    public clearUsageCache() {
        Cache.removeItem("FlurryUsage");
    }

    // Event params

    public async fetchEventParams(timeInterval:TimeInterval, dataSource:DataSource): Promise<any> {
        this.loadEventParamsCacheIfAvailable();
        if (this.eventParams.length > 0) {
            console.log(this.eventParams);
            return P.resolve(this.eventParams);
        }

        var self = this;
        return new Promise<any>(async function(resolve) {
            /*var input = {
                field: InvokeFields.getFlurryEventParams,
                dataSourceId: dataSource.id,
                // TODO: Disabling right now for event params
                //fromDate: DashboardDateUtil.getPreviousTimeInterval().start,
                fromDate: timeInterval.start,
                toDate: timeInterval.end,
                interval: timeInterval.interval
            }
            console.log(input);
            self.eventParams = await getGlobal().dataManager.get("getFlurryEventParams", input);*/
            self.eventParams = await FlurryEventParamsAPI.get(timeInterval.start, timeInterval.end, timeInterval.interval, self.getApiKeys(dataSource));
            console.log("Event Params", self.eventParams);

            // TODO: Put this on the actual object
            if (self.eventParams) {
                for (let eventParam of self.eventParams) {
                    let paramValueObject = eventParam.paramValue;
                    try {
                        paramValueObject = JSON.parse(eventParam.paramValue);
                    } catch (e) {
                    }
                    eventParam.paramValue = paramValueObject;
                }
            }

            //console.log(self.eventParams);
            self.cacheEventParamsData();
            resolve(self.eventParams);
        });
    }

    public getApiKeys(dataSource:DataSource):Array<string> {
        let params = JSON.parse(dataSource.params);
        let apiKeys:Array<string> = [];
        if (!StringUtil.isNullOrEmpty(params.appleFlurryApiKey)) {
            apiKeys.push(params.appleFlurryApiKey);
        }
        if (!StringUtil.isNullOrEmpty(params.googleFlurryApiKey)) {
            apiKeys.push(params.googleFlurryApiKey);
        }
        return apiKeys;
    }

    public loadEventParamsCacheIfAvailable() {
        let cacheData = Cache.getItem("FlurryEventParams");
        if (cacheData) {
            console.log("Loading FlurryEventParams from cache");
            this.eventParams = cacheData;
        }
    }

    public cacheEventParamsData() {
        Cache.setItem("FlurryEventParams", this.eventParams);
    }

    public clearEventParamCache() {
        Cache.removeItem("FlurryEventParams");
    }
}